import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {SharedService} from '../../shared/shared.service';
import {Constants} from '../../shared/Helpers/constants';
import { SocialLoginService } from 'src/app/_services';
import { SocialProviderNameEnum } from 'src/app/enums/enums';

@Component({
  selector: 'app-authentication-google-callback',
  templateUrl: './authentication-google-callback.component.html'
})
export class AuthenticationGoogleCallbackComponent implements OnInit {
  public logoPath: any = null;
  public linkCheckErrorMessage: string = null;
  public showSignedUpSuccessfully: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private socialLoginService: SocialLoginService,
    private sharedService: SharedService
  ) { }

  ngOnInit() {
    let code: any;
    let state: any;
    this.route.queryParams.subscribe((res: Params) => {
      code = res.code;
      state = res.state;
    });
    this.socialLoginService.getAuthenticationEmailSignUpOAuthCallback(SocialProviderNameEnum.Google, code, state).subscribe({
      next: (res) => {
        this.showSignedUpSuccessfully = true;
      },
      error: (err) => {
        this.linkCheckErrorMessage = err.error.detailedMessage;
      }
    });
  }

  ngDoCheck() {
    if (this.sharedService.loadedOrganisationByUrl.value) {
      if (this.sharedService.loginCustomisation.value != undefined && this.sharedService.loginCustomisation.value != null) {
        if (this.sharedService.LogoImage.value != null) {
          this.logoPath = null;
          this.logoPath = this.sharedService.LogoImage.value;
        } else {
          this.logoPath = Constants.logoPath;
        }
      } else {
        this.logoPath = Constants.logoPath;
      }
    } else {
      this.logoPath = Constants.logoPath;
    }
  }

}
